import Vue from 'vue'

const pattern = /[^0-9.]/g;

Vue.directive('digitsAfterDecimal', {
  bind(el, binding) {
    el.oninput = () => {
      const fractionDigits = binding.value;
      let value = el.value.replace(pattern, '');
      if (value) {
        let arr = value.split('.');
        if (arr[1] && arr[1].length > fractionDigits.numberOfDigits) {
          arr[1] = arr[1].slice(0, fractionDigits.numberOfDigits);
        }
        el.value = arr.join('.');
      }
    }
  }
});

Vue.directive('replaceWithNegative', {
  update(el) {
    const event = new Event('input', { bubbles: true });
    const value = el.value.replace(pattern, '');
      if (value) {
        el.value = Number(value) ? `-${value}` : value;
        el.dispatchEvent(event);
      }
  }
});

Vue.directive('replaceWithNegativeAndDigitsDecimal', {
  bind(el, binding) {
    el.oninput = () => {
      let fractionDigits = binding.value;
      let value = el.value.replace(pattern, '');
      if (value) {
        let arr = value.split('.');
        if (arr[1] && arr[1].length > fractionDigits.numberOfDigits) {
          arr[1] = arr[1].slice(0, fractionDigits.numberOfDigits);
        }
        el.value = `-${arr.join('.')}`;
      }
    }
  }
});

Vue.directive('replaceWithPositive', {
  bind(el) {
    el.oninput = () => {
      const value = el.value.replace(pattern, '');
      if (value) {
        el.value = value;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/directives/NumericInputDirectives.js